// as previously seen in plugins.js, use this instead
// optional queryString, defaults to location.search

export default function getParameterByName(name, queryString) {
  name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i');
  var results = queryString ? regex.exec(queryString) : regex.exec(location.search);
  return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
